module.exports = __webpack_public_path__ + "img/CHIHUAHUA_1.4eede812.png";